import React, { Fragment, useState } from 'react'
import { Dialog } from '../../../components/ui/dialog'
import { Table } from '../../../components/ui/Table'
import { format, fromUnixTime } from 'date-fns'
import { useTableHooks } from '../../../packages/blueprint-components/src/useTableHooks'
import { useRecoilValue } from 'recoil'
import { updateDetailsLogState, updateLogErrorCount } from './update_details_log_state'
import { Icon } from '@blueprintjs/core'
import { JsonView, defaultStyles } from 'react-json-view-lite'
import 'react-json-view-lite/dist/index.css'
import { Column } from '../../../types/table'

export const UpdateDetailLogs = () => {
    const items = useRecoilValue(updateDetailsLogState)
    const errCount = useRecoilValue(updateLogErrorCount)
    const [detail, setDetail] = useState<null | object>(null)

    const tableHooks = useTableHooks<any>(() =>
        Promise.resolve({
            data: { data: [] },
        }),
    )
    tableHooks.items = items ?? []

    const columns: Column<any, any>[] = [
        { key: 'level' },
        {
            key: ' ',
            title: 'Details',
            cell: (row) => {
                return (
                    <Icon
                        icon="info-sign"
                        onClick={() => {
                            setDetail(JSON.parse(row.rest))
                        }}
                    />
                )
            },
        },
        {
            key: 'update_snapshot_id',
            title: 'Snapshot Id',
        },
        {
            key: 'update_report_id',
            title: 'Report Id',
        },
        {
            key: 'timestamp',
            cell: ({ timestamp }) => format(new Date(fromUnixTime(timestamp)), 'M/d/yy H:mm a'),
        },
        { key: 'message' },
        { key: 'target' },
    ]

    return (
        <div>
            <Table
                name={`Update Logs${errCount ? ` (${errCount} errors)` : ''}`}
                showHeader
                className=""
                filters={null}
                canSelect={false}
                columnSelection={false}
                columns={columns}
                tableHooks={tableHooks}
                onSelectChange={null}
                height={300}
            />
            <Dialog isOpen={!!detail} onClose={() => setDetail(null)} className="p-4">
                {detail && (
                    <Fragment>
                        <JsonView
                            data={detail}
                            shouldInitiallyExpand={() => true}
                            style={defaultStyles}
                        />
                    </Fragment>
                )}
            </Dialog>
        </div>
    )
}
